<template>
  <div class="search">
    <search-results></search-results>
  </div>
</template>

<script>
import SearchResults from '../components/search/SearchResults.vue'

export default {
  name: 'Search',
  components: {
    SearchResults,
  },
  mounted() {
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>

<style lang="scss" scoped>
.search {
  background-color: var(--dark-gray);
  padding: 150px 10px;
  min-height: 100vh;
  @include mobile {
    padding: 175px 25px 150px 25px;
  }
}
</style>
